module.exports = __webpack_public_path__ + "img/logo-mini.8873900c.svg";